<template>
  <div v-if="ready">
    <div class="form-horizontal device-status">
      <div class="device-status-row">
        <div class="device well">
          <div class="head">
            <div>
              <span style='vertical-align:baseline;'>{{tree.tech_name}}&nbsp;<small class="label label-success">{{workingCount}}</small>&nbsp;<a style="font-size: smaller" :href="`/device/pon/${tree.head}/status`">{{headName}}</a></span>
            </div>
            <div style='width:10px;'></div>
            <div class="cursor-pointer">
              <Icon name="fa-eye-slash" title='Прошлое состояние портов' @click="showOldCounters=!showOldCounters" />
              &nbsp;&nbsp;
              <Icon name="fa-users" title='Абоненты' @click="lower='o'; unselectPort()" />
            </div>
          </div>
          <div class="ports">
            <div class="ports-group" v-for="i in 4" :key=i>
              <div class="port-group" v-for="j in 16" :key=j :class="{active: selectedPort==(i-1)*16+j}" :title="onu[(i-1)*16+j].deregistered">
                <div class="port-number port-graph cursor-pointer" 
                  :class="{online_unt: !onu[(i-1)*16+j].deregistered && !onu[(i-1)*16+j]._empty, offline_adm: onu[(i-1)*16+j].deregistered}"
                >
                {{(i-1)*16+j}}
                </div>
                
                <div class="port port-mac-current port-info" @click="selectPort((i-1)*16+j)" 
                  :class="`level-${onu[(i-1)*16+j].level}`" :title="onu[(i-1)*16+j].problems.join('\n')" v-if="showLevels">
                  {{counters[(i-1)*16+j]}}
                </div>
                <div class="port port-mac-current port-info" @click="selectPort((i-1)*16+j)" v-else>{{counters[(i-1)*16+j]}}</div>

                <div class="port port-mac-old cursor-pointer" v-show="showOldCounters">{{oldCounters[(i-1)*16+j]}}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <PonAbonents :onus=onu :showPeriod=true v-if="lower=='o'" />
    <Tabs :tabs=ponTreeTabs :state=state :extra=extra v-else-if="!emptyPort"/>

  </div>
  <div v-else>
    Данные загружаются...
  </div>
</template>

<script>
import darsan from "darsan"
import {fromUnixtime, iconClass} from "common"

import Tabs from "common/visual/Tabs.vue"
import PonAbonents from "device/status/modules/pon_tree/PonAbonents.vue"

export default {
  name: "PonTree",
  
  props: 
  {
    state: Object,
    dialog: Object,
    port: Number,
  },
  
  components: {Tabs, PonAbonents},
  
  data()
  {
    return {
      ready: false,
      tree: {},
      onu: [],
      selectedPort: null,
      emptyPort: true,
      extra: {},
      title: "",
      counters: [],
      oldCounters: [],
      showOldCounters: false,
      lower: "",
      headName: "",
      ponTreeTabs: [
        { modPath: 'device/status/modules/pon_tree/PonTreeMac', name: "ponTreeMac", text: "Абоненты", defaultTab: true, subpath: "", icon: "fa-users" },
        { modPath: 'device/status/modules/pon_tree/PonTreePortGraph', name: "ponTreePortGraph", text: "Графики", defaultTab: true,  subpath: "port-graph", icon: "stats" },
        { modPath: 'device/status/modules/pon_tree/PonTreeOnu', name: "ponTreeOnu", text: "ONU", defaultTab: true, subpath: "onu", icon: "tasks" },
      ],
    }
  },
  
  created()
  {
    this.ensure("device-tags")
  },

  mounted()
  {
    this.load()
  },
  
  methods: {
    async load()
    {
      this.tree = await darsan.get("", "device", `/pontree/${this.state.treeId}`)
      
      const tags = await darsan.get("", "device", `/pontree/${this.state.treeId}/tag`)

      const icons = this.$store.state.preload["/device-tags"]
      .filter(
        d => d.device_type=="pontree" && d.entity in tags && d.icon && (tags[d.entity]===null ? d.default_value : tags[d.entity])
      )
      .map(d => `<i class="${Object.keys(iconClass(d.icon)).join(' ')}" title="${d.name_ru}"></i>`)
      .join("&nbsp;")

      this.dialog.setTitle(this.tree.description + "&nbsp;&nbsp;&nbsp;&nbsp;" + icons)
      
      const head = await darsan.get("", "device", `/device/${this.tree.head}`)
      this.headName = head.name_ru
      
      const list = new Array(64+1).fill({_empty: true})
      const onu = await darsan.get("", "device", `/pon/${this.tree.head}/tree/${this.tree.tree}/onu`)
      
      for (const el of onu)
      {
        list[el.onu_port] = el
      }

      this.onu = list
      
      this.counters = list.map(el => el._empty ? "" : (el.fdb.length==0 ? "" : el.fdb.length))
      this.oldCounters = list.map(el => el._empty ? "" : (el.old_fdb.length==0 ? "" : el.old_fdb.length))
      
      for (const el of list)
      {
        this.findProblems(el)
      }

      if (this.state.port) this.selectPort(this.state.port)
      
      this.ready = true
    },
    
    selectPort(port)
    {
      this.selectedPort = this.extra.port = port
      this.extra.onu = this.onu[port]
      this.emptyPort = this.onu[port]._empty
      this.lower = ''
      
      const tab = this.ponTreeTabs.find(el => el.name=="ponTreeOnu")
      tab.text = this.extra.onu.name
    },
    
    unselectPort()
    {
      this.selectedPort = this.extra.port = null
    },
    
    findProblems(onu)
    {
      let level = 0
      const problems = []
      
      if (onu._empty)
      {
        onu.level = 4
        onu.problems = []
        return
      }
      
      if (onu.deregistered)
      {
        onu.level = 3
        onu.problems = [ `${onu.deregistered} (с ${fromUnixtime(onu['dereg-from'])})` ]
        return
      }
      
      const temperature = onu.temperature || 0
      if (temperature > 70)
      {
        level = 2
        problems.push("Критически высокий перегрев. Возможен выход из строя")
      }
      else if (temperature > 50)
      {
        level = 1
        problems.push("Высокий перегрев устройства")
      }
      
      const olt_rx = onu.olt_rx
      if (olt_rx < -30)
      {
        level = 2
        problems.push("Критически низкий уровень сигнала от ONU/Абонента")
      }
      else if (olt_rx < -26)
      {
        level = 1
        problems.push("Низкий уровень сигнала от ONU/Абонента")
      }

      const onu_rx = onu.onu_rx
      if (onu_rx < -30)
      {
        level = 2
        problems.push("Критически низкий уровень сигнала от OLT/Станции")
      }
      else if (onu_rx < -26)
      {
        level = 1
        problems.push("Низкий уровень сигнала от OLT/Станции")
      }
      
      onu.level = level
      onu.problems = problems
    },
  },
  
  computed: {
  
    existingOnuList()
    {
      return this.onu.filter(el=>!("_empty" in el))
    },
    
    workingCount()
    {
      return this.existingOnuList.length
    },
    
    showLevels()
    {
      return this.lower == "o"
    },
  },
}
</script>

<style scoped>
.icon
{
  position: static;
  font-size: 120%;
}

.level-0
{
}

.level-1
{
  background: yellow;
}

.level-2
{
  background: orange;
}

.level-3
{
  background: LightPink;
}

.level-4
{
  background: LightGray;
}
</style>

